module.exports = __webpack_public_path__ + "img/1280.29e38249.svg";